import { useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AudioContext } from './contexts/AudioContext';
import { WalletProvider } from './features/wallet/contexts/WalletContext';
import { TonConnectProvider } from './contexts/TonConnectContext';
import AudioManager from './components/AudioManager';
import RewardCenter from './features/rewards/components/RewardCenter';
import { fetchNotifications } from './store/slices/countersSlice';

/**
 * Компонент, объединяющий все провайдеры приложения
 *
 * Инкапсулирует всю логику провайдеров:
 * - WalletProvider для WebSocket соединения
 * - TonConnectProvider для TON Connect интеграции
 * - AudioContext для управления аудио
 *
 * При монтировании загружает счётчики уведомлений для меню (GET /v1/notifications).
 * WebSocket (counter.updated / counters.updated) поддерживает их актуальность в реальном времени.
 */
export const AppProviders = ({ children, userId }) => {
  const audioManagerRef = useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    if (userId) {
      dispatch(fetchNotifications());
    }
  }, [userId, dispatch]);

  return (
    <WalletProvider userId={userId}>
      <TonConnectProvider>
        <AudioContext.Provider value={audioManagerRef}>
          <AudioManager ref={audioManagerRef} />
          <RewardCenter />
          {children}
        </AudioContext.Provider>
      </TonConnectProvider>
    </WalletProvider>
  );
};

